import { SliderProps as AndroidSliderProps } from '@react-native-community/slider';
import React, { useEffect } from 'react';
import { getTrackBackground, Range } from 'react-range';
import useFontSize from '../../../shell/hooks/useFontSize';
import { StyleSheet } from 'react-native';


interface SliderProps extends AndroidSliderProps {
}

export const TSlider: React.FC<SliderProps> = ({ style, onValueChange, value, ref, ...rest }) => {
    let _value = value;
    if (value) {
        if (rest.minimumValue) {
            if (rest.minimumValue > value) {
                _value = rest.minimumValue;
            } else if (rest.maximumValue && rest.maximumValue < value) {
                _value = rest.maximumValue;
            }
        }
    }


    const [values, setValues] = React.useState([_value ?? 50]);
    useEffect(() => {
        if (onValueChange) {
            onValueChange(values[0]);
        }


    }, [values]);


    const styles = StyleSheet.create({
        thumb: {
            height: useFontSize(5),
            width: useFontSize(5),


        },


    });

    return (
        <>
            {/* <Slider step={0.01} min={0} max={100} /> */}
            <Range
                {...rest}
                step={rest.step || 0.1}
                min={rest.minimumValue || 0}
                max={rest.maximumValue || 100}
                values={values}
                onChange={(values) => { setValues(values); }}

                renderTrack={({ props, children }) => (
                    <div
                        onMouseDown={props.onMouseDown}
                        onTouchStart={props.onTouchStart}
                        style={{
                            ...props.style,
                            height: '36px',
                            display: 'flex',
                            width: '100%'
                        }}
                    >
                        <div
                            ref={props.ref}
                            style={{
                                height: '5px',
                                width: '100%',
                                borderRadius: '4px',
                                background: getTrackBackground({
                                    values,
                                    colors: ['#f454d2', '#ccc'],
                                    min: rest.minimumValue || 0,
                                    max: rest.maximumValue || 100,
                                }),
                                alignSelf: 'center'
                            }}
                        >
                            {children}
                        </div>
                    </div>
                )}

                renderThumb={({ props }) => (
                    <div
                        {...props}
                        style={{
                            ...styles.thumb,
                            ...props.style,
                            borderRadius: "50%",
                            backgroundColor: 'white'
                        }}
                    />
                )}
            />
        </>
    );
};